import React from "react";
import { CallDispositionsTableActions } from "./CallDispositionsTableActions";

export const getCallDispositionsTableColumns = ({
  parentDispositions = [],
}) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      width: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Parent",
      id: "Parent",
      accessorKey: "parent_name",
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Type",
      id: "Type",
      accessorKey: "type",
    },
    {
      header: "DNC",
      id: "DNC",
      accessorKey: "dnc",
    },
    {
      header: "Invalid",
      id: "Invalid",
      accessorKey: "invalid",
    },
    {
      header: "Is Successful",
      id: "Is Successful",
      accessorKey: "is_successful",
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CallDispositionsTableActions
          original={row.original}
          parentDispositions={parentDispositions}
        />
      ),
    },
  ];
};
